import * as React from 'react';

import type { LegalAdminClient } from '@/api/legal-admin-client';
import { HttpLegalAdminClient } from '@/api/legal-admin-client.http';

// Impl HTTP réelle par défaut (Phase 2, D2a-LECT) : le stub reste injectable via le
// provider pour les tests. Instance partagée (lectures pures, sans état interne).
const defaultLegalAdminClient: LegalAdminClient = new HttpLegalAdminClient();

// =============================================================================
// legal-admin-client-context.tsx — Injection du LegalAdminClient (DI seam).
// =============================================================================
// Permet de substituer le client (double déterministe en test, impl HTTP réelle
// plus tard) sans toucher l'UI. Par défaut : le StubLegalAdminClient (Option B).
// Séparé du LegalClientProvider (fournisseur) : l'accès admin au statut CGU est un
// concern DISTINCT (décision GATE_0 S5bis).

const LegalAdminClientContext = React.createContext<LegalAdminClient>(
  defaultLegalAdminClient,
);

export interface LegalAdminClientProviderProps {
  client?: LegalAdminClient | undefined;
  children: React.ReactNode;
}

export function LegalAdminClientProvider({
  client = defaultLegalAdminClient,
  children,
}: LegalAdminClientProviderProps): React.JSX.Element {
  return (
    <LegalAdminClientContext.Provider value={client}>
      {children}
    </LegalAdminClientContext.Provider>
  );
}

export function useLegalAdminClient(): LegalAdminClient {
  return React.useContext(LegalAdminClientContext);
}
